<template>
  <div class="idc-wrap">
    <!-- 标题区域 -->
    <div class="row mb-1">
      <div class="col-12">
        <h2 class="title-main">
          {{ $t('data_card.title') }}
        </h2>
        <p class="title-sub">{{ $t('data_card.title_sub') }}</p>
      </div>
    </div>

    <!-- Bootstrap 五列布局 row + col -->
    <div class="row">
      <div class="col-md col-item">
        <div class="num css-count" data-end="30">
          <span class="num-val"></span>+
        </div>
        <div class="label">
          {{ $t('data_card.city.name') }}
          <!-- 城市  -->
        </div>
        <div class="desc">
          {{ $t('data_card.city.text') }}
        </div>
      </div>
      <div class="col-md col-item">
        <div class="num css-count" data-end="50">
          <span class="num-val"></span>+
        </div>
        <div class="label">{{ $t('data_card.datacetre.name') }}</div>
        <div class="desc">
          {{ $t('data_card.datacetre.text') }}
        </div>
      </div>
      <div class="col-md col-item">
        <div class="num css-count" data-end="4">
          <span class="num-val"></span>T+
        </div>
        <div class="label">{{ $t('data_card.memory.name') }}</div>
        <div class="desc">
          {{ $t('data_card.memory.text') }}
        </div>
      </div>
      <div class="col-md col-item">
        <div class="num css-count" data-end="907">
          <span class="num-val"></span>MW
        </div>
        <div class="label">{{ $t('data_card.capacity.name') }}</div>
        <div class="desc">
          {{ $t('data_card.capacity.text') }}
        </div>
      </div>
      <div class="col-md col-item">
        <div class="num css-count" data-end="49000" data-format="true">
          <span class="num-val"></span>+
        </div>
        <div class="label">{{ $t('data_card.cabinet.name') }}</div>
        <div class="desc">{{ $t('data_card.cabinet.text') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IdcBootstrapCard',
  mounted() {
    this.startCssCountAnimation();
  },
  methods: {
    startCssCountAnimation() {
      const items = document.querySelectorAll('.css-count');
      const duration = 5000; // 动画时长 ms

      items.forEach((el) => {
        const end = Number(el.dataset.end);
        const needFormat = el.dataset.format === 'true';
        const valDom = el.querySelector('.num-val');
        const startTime = performance.now();

        function animate(time) {
          const progress = Math.min((time - startTime) / duration, 1);
          const current = Math.floor(progress * end);
          // 千分位格式化
          valDom.innerText = needFormat ? current.toLocaleString() : current;

          if (progress < 1) {
            requestAnimationFrame(animate);
          }
        }
        requestAnimationFrame(animate);
      });
    },
  },
};
</script>

<style scoped>
.idc-wrap {
  color: #fff;
  background-image: url('@/assets/images/cc/bg.gif');
  background-size: cover;
  background-repeat: no-repeat;

  margin: 20px 0;
  border-radius: 10px;
  overflow: hidden;
}

.title-main {
  font-size: 26px;
  font-weight: 700;
  margin: 30px 0 0 0;
  padding: 0 20px;
}
.title-sub {
  font-size: 18px;
  margin: 0 0 15px 0;
  padding: 0 20px;
}

.col-item {
  padding: 24px 16px;
  border-right: 1px solid #ffffff40;
  /* 加上过渡动画，所有变化平滑执行 */
  transition: all 0.3s ease;
  &:hover {
    cursor: pointer;
    margin-top: -3px;
    /* 可以加一点上浮配套阴影，增强悬浮立体感 */
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25);
  }
}
.col-item:last-child {
  border-right: none;
}

.num {
  font-size: 34px;
  font-weight: bold;
  margin-bottom: 12px;
}
.label {
  font-size: 18px;
  margin-bottom: 16px;
}
.desc {
  font-size: 14px;
  line-height: 1.6;
  text-align: center;
}
</style>
